import styled from 'styled-components';

export const FAQsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    @media only screen and (max-width: 600px) {
        align-items: center;
    }
`;

export const FAQsParagraph = styled.div`
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};
    // width: 90%;
    text-align: left;

    div {
    margin: 1rem 0;
    }

    b {
    font-weight: bold;
    color: ${props => props.theme.evTeal};
    }

    @media only screen and (max-width: 600px) {
        width: 100%;
    }

`;